import { useEffect } from 'react'

// import AdModal from './components/AdModal/AdModal'
import { query2Obj } from 'starit-util'
import Layout from 'component/Layout'
import Banner from './components/Banner/Banner'
import Solution from './components/Solution/Solution'
import Introduce from './components/Introduce/Introduce'
import Users from './components/Users/Users'

interface propTypes {
  lang: Lang,
}
interface QueryInfo {
  pr?: string,
  [propsName: string]: any
}

export default function Home (props: propTypes) {
  const { lang } = props

  useEffect(() => {
    const { pr } = query2Obj(location.search) as QueryInfo
    if (pr) window.sessionStorage.setItem('promotion_alliance_code', pr)
    window?.fbq?.('track', 'ViewContent')
  }, [])

  return (
    <Layout
      className={`home ${lang}`}
      lang={lang}
      activeHref='/'
    >
      <Banner lang={lang} />
      <Solution lang={lang} />
      <Introduce lang={lang} />
      <Users lang={lang} />
      {/* <AdModal lang={lang} /> */}
    </Layout>
  )
}
